var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8264 4.01071L8.85256 0.167857C8.74176 0.0607143 8.59219 0 8.43523 0H0.590909C0.264062 0 0 0.255357 0 0.571429V15.4286C0 15.7446 0.264062 16 0.590909 16H12.4091C12.7359 16 13 15.7446 13 15.4286V4.41607C13 4.26429 12.9372 4.11786 12.8264 4.01071ZM11.6372 4.67857H8.16193V1.31786L11.6372 4.67857ZM11.6705 14.7143H1.32955V1.28571H6.90625V5.14286C6.90625 5.34177 6.98796 5.53254 7.13341 5.67319C7.27886 5.81384 7.47613 5.89286 7.68182 5.89286H11.6705V14.7143Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.19fc2436e2530966cd8b1de05f1ff82f.svg";
export { ForwardRef as ReactComponent };